import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/projects/saas/page.tsx");
